export default __webpack_public_path__ + "static/media/josh-calabrese-qmnpqDwla_E-unsplash-min.ad719223.jpg";